import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import SelfServeCreditService from 'services/selfServeCredit/selfServeCredit.service';
import { setSorting } from './slice';

const getErrorMessage = (error) =>
	error?.response?.data?.errors?.[0] ||
	error?.data?.errors?.[0] ||
	error?.error?.errors?.[0] ||
	error?.error?.message ||
	error?.message ||
	'Unable to load credits.';

const normalizeMetadata = (metadata = {}, requestedPage, requestedPerPage) => ({
	links: metadata.links || {},
	page: Number(metadata.page) || requestedPage,
	page_count: Number(metadata.page_count) || 0,
	per_page: Number(metadata.per_page) || requestedPerPage,
	selfServeCreditSummary: metadata.selfServeCreditSummary || null,
	total_count: Number(metadata.total_count) || 0,
});

export const fetchSelfServeCredits = createAsyncThunk(
	'selfServeCredits/fetchSelfServeCredits',
	async ({ page = 1, perPage = 25, sortBy, direction } = {}, { rejectWithValue, signal }) => {
		const cancelSource = axios.CancelToken.source();
		signal.addEventListener('abort', () => {
			cancelSource.cancel();
		});

		try {
			const response = await SelfServeCreditService.instance.getCredits(
				{
					page,
					perPage,
					sortBy,
					direction,
				},
				cancelSource.token,
			);
			const responseData = response?.data || {};

			if (responseData.success === false) {
				return rejectWithValue('Unable to load credits.');
			}

			return {
				credits: Array.isArray(responseData.data) ? responseData.data : [],
				metadata: normalizeMetadata(responseData.metadata, page, perPage),
			};
		} catch (error) {
			return rejectWithValue(getErrorMessage(error));
		}
	},
);

export const updateSelfServeCreditsSorting =
	({ sortBy, direction }) =>
	(dispatch) => {
		dispatch(setSorting({ sortBy, direction }));
		return dispatch(fetchSelfServeCredits({ page: 1, sortBy, direction }));
	};
